export enum FontSize {
  F12 = "12px",
  F14 = "14px",
  F16 = "16px",
  F18 = "18px",
  F20 = "20px",
  F22 = "22px",
  F24 = "24px",
  F28 = "28px",
}
